/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_SdkInputs */

const en_directory_agent_readiness_check_sdk = /** @type {(inputs: Directory_Agent_Readiness_Check_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDK`)
};

const zh_directory_agent_readiness_check_sdk = /** @type {(inputs: Directory_Agent_Readiness_Check_SdkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SDK`)
};

/**
* | output |
* | --- |
* | "SDK" |
*
* @param {Directory_Agent_Readiness_Check_SdkInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_sdk = /** @type {((inputs?: Directory_Agent_Readiness_Check_SdkInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_SdkInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_sdk(inputs)
	return zh_directory_agent_readiness_check_sdk(inputs)
});
export { directory_agent_readiness_check_sdk as "directory.agent_readiness.check.sdk" }